import { t } from '../utils/i18n'
import InlineSvg from './InlineSvg'

const PlusButton = ({ onClick }) => (
  <div
    className="velorbis-customizer-header-tool"
    title={'Next color'}
    onClick={onClick}
  >
    <div className="velorbis-customizer-header-tool-inner">
      <InlineSvg src="icons/plus" />
    </div>
  </div>
)

export default PlusButton
